import React, { useCallback, useEffect, useState } from "react";
import { cloneDeep, filter, find, forEach, get, head, includes, isEmpty, map, noop, size, isEqual , set} from "lodash";
import classNames from "classnames";
import { Collapse, Radio, Empty, Spin, Button, Modal, Input, Select } from "antd";
import { UserOutlined } from "@ant-design/icons";

// adding local dependencies
import "./task.scss";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import CareCoordinationService from "../../../../../services/care-coordination";
import "./task.scss";
import { ActionFreeText, ActionNoValue, ActionRadio, ACTIVE, COMPLETE, NOT_APPLICABLE, Info, INPROGRESS, CARE_MANAGEMENT_TASK_STATUS_DROPDOWN_MAPPING } from "../../constants";
import InputField from "../input/input";
import Icon from "../../../../../assets/icon_config";
import Notes from "../notes/notes";
import SubTask from "./subTask";
import Remainder from "../remainder/remainder";
import { ReadMoreForWidth } from "@components/readMore/readMore";
import { CARE_MANAGEMENT_SCREEN_TITLE, CASE_STATUS_REASON_TASK_STATUS, MEMBER_DETAILS_CARE_MANAGEMENT_TASKS, USER_ACTION_CARD_PROGRAM, USER_ACTION_DESCRIPTION_TASK_STATUS_CHANGE, USER_ACTION_LOCATION_TASK_DROPDOWN, USER_ACTION_MODULE_MEMBER_DETAIL, USER_ACTION_TAB_CARE_MANAGEMENT } from "@utils/constants";
import classnames from "classnames";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { DateRange } from "@components/dateRange";
import moment from "moment";
import { RangePickerProps } from "antd/lib/date-picker";
import { CareManagementCanEdit } from "@components/accessLevel/careManagementCanEdit";
import membersService from "@services/members.service";
import { MandatoryWarning } from "../mandatoryWarning";
import DataNotFound from "@components/noDataFound";
import { NO_TASK_ASSIGNED } from "../../../../../constants/constants";
import { formatDisplayDate } from "@utils/helpers";

const { Panel } = Collapse;
const { Option } = Select;

/******************************************************************************* */

// Code practice - while updating active program state of store, please update previous program state accordingly this is to handle and maintain history across intervention

/******************************************************************************* */

const Task = (props: {
  taskGroupName?: string;
  showTaskGoals?: boolean;
  programId: any;
  interventionId: any;
  tasks: any;
  patientId: any;
  patientProgramId: any;
  onChangeProgram?: any;
  programName: string;
  programEndDate: any;
  updatedProgramEndDate?: any;
  setProgramEndDate?: any;
  stopPropagation?: any;
  canEdit: boolean;
  showAssignee: boolean;
}) => {
  const driversList = useCareCoordinationStore((state) => state.driversList);
  // calculating min and max task start and end date
  const createDateArray = props.tasks.map((value: { taskCreateDate: any }) => new Date(value.taskCreateDate));
  const minCreateDate = moment
    .utc(new Date(Math.min(...createDateArray)))
    .local()
    .format("MM-DD-YYYY");
  const endDateArray = props.tasks.map((value: { taskEndDate: any }) => new Date(value.taskEndDate));
  const maxEndDate = moment
    .utc(new Date(Math.max(...endDateArray)))
    .local()
    .format("MM-DD-YYYY");

  const [isAddTaskModalVisible, setIsAddTaskModalVisible] = useState(false);
  const [selectedNewTask, setSelectedNewTask] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [addTaskOptions, setAddTaskOptions] = useState<{ id: any; description: string }[] | never[]>([]);
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);
  const [activePanel, setActivePanel] = useState<any>([]);

  // getting state from the Store
  const isAllComplete = useCareCoordinationStore((state) => state.isAllComplete);
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const programsData = cloneDeep(useCareCoordinationStore((state) => state.dataForCareCoordination));
  const setPreviousDataForCareCoordination = useCareCoordinationStore((state) => state.setPreviousDataForCareCoordination);
  const previousDataForCareCoordination = cloneDeep(useCareCoordinationStore((state) => state.previousDataForCareCoordination));

  const [loaders, setloaders] = useState(0)

  const isLoading = loaders > 0

  const setIsLoading = (load: boolean) => {
    setloaders(
      loaders => {
        if (load) {
          loaders++
        } else {
          loaders--
        }
        return loaders
      }
    )
  }

  // const [isLoading, setIsLoading] = useState(false);
  const [updatingTaskLoader, setUpdatingTaskLoader] = useState(false);

  // finding out active program and active intervention
  const activeProgram = programsData;
  const activeIntervention = find(activeProgram?.interventions, { id: props?.interventionId });

  // finding out active program and intervention previous state
  const activeProgramPreviousState = previousDataForCareCoordination;
  const activeInterventionPreviousState = find(activeProgramPreviousState?.interventions, { id: props?.interventionId });

  const patientId = props.patientId;
  const updatedProgramEndDate = moment(props.updatedProgramEndDate);

  // updating the task
  const updateTask = useCallback(
    ({ status, taskId, value, taskEndDate, taskCreateDate, activeTaskFromSubTask = undefined, newReminder, stopPrevProgramDataUpdate, callback = noop }: any) => {
      const activeTask = find(activeIntervention?.tasks, { id: taskId });
      const activeTaskPreviousState = find(activeInterventionPreviousState?.tasks, { id: taskId });

      const _taskEndDate = taskEndDate === undefined || taskEndDate === null || taskEndDate === "" ? undefined : moment.utc(taskEndDate);
      const _taskCreateDate = taskCreateDate === undefined || taskCreateDate === null || taskCreateDate === "" ? undefined : moment.utc(taskCreateDate);
      if (activeTaskFromSubTask) {
        activeTask.status = activeTaskFromSubTask.status;
        activeTask.subtasks = activeTaskFromSubTask.subtasks;

        const detail = find(activeIntervention?.interventionDetails, { labelId: activeTaskFromSubTask?.extra?.id });
        if (detail) {
          detail.value = activeTaskFromSubTask?.extra?.value?.replaceAll("'", "");
        }
      }
      const _value = isEmpty(value) ? "" : value;

      const _status = status;

      // if (activeTask.status !== _status || activeTask.value !== _value) {
      setIsLoading(true);

      CareCoordinationService.updateTask({
        patientId: patientId,
        programId: props.programId,
        interventionId: props?.interventionId,
        status: _status,
        taskId,
        value: _value,
        taskCreateDate: _taskCreateDate,
        taskEndDate: _taskEndDate,
      }).subscribe({
        next: (v) => {
          activeTask.status = _status;
          activeTask.value = _value;

          activeTaskPreviousState.status = _status;
          activeTaskPreviousState.value = _value;

          if (_taskEndDate !== undefined && _taskEndDate !== null) {
            activeTask.taskEndDate = _taskEndDate;
            activeTaskPreviousState.taskEndDate = _taskEndDate;
          }
          if (_taskCreateDate !== undefined && _taskCreateDate !== null) {
            activeTask.taskCreateDate = _taskCreateDate;
            activeTaskPreviousState.taskCreateDate = _taskCreateDate;
          }

          if (_status === COMPLETE || _status === NOT_APPLICABLE) {
            activeTask.subtasks = activeTaskPreviousState.subtasks;
          }

          

          if (newReminder) {
            if (!isEmpty(activeTask.reminders)) {
              activeTask.reminders = [...cloneDeep(activeTask.reminders), ...newReminder];
              activeTaskPreviousState.reminders = [...cloneDeep(activeTask.reminders), ...newReminder];
            } else {
              activeTask.reminders = newReminder;
              activeTaskPreviousState.reminders = newReminder;
            }
          }
          
          if (_status === COMPLETE) {
            //
            const updatedReminderList = cloneDeep(activeTask?.reminders?.filter((reminder:any) => moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) < moment()));
            set(activeTask , 'reminders', updatedReminderList);
            forEach(activeTask.subtasks, (item: any) => {
              const updatedSubTaskReminders = cloneDeep(item?.reminders?.filter((reminder:any) => moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) < moment()));
              set(item , 'reminders', updatedSubTaskReminders);
            });
          }
          setProgramsData(programsData);
          setPreviousDataForCareCoordination(previousDataForCareCoordination);
          setIsLoading(false);
          callback();
        },
        error: (e) => {
          console.log(e);
          setIsLoading(false);
        },
      });
      // }
    },
    [activeIntervention?.interventionDetails, activeIntervention?.tasks, patientId, programsData, props?.interventionId, props.programId, setProgramsData, setPreviousDataForCareCoordination]
  );

  // Updating task end date for Program end date updation
  useEffect(() => {
    // updating task-end date for program target date change
    const updateTaskEndDate = (source_of_function_call: string) => {
      if (moment.utc(props.programEndDate).local().format("YYYY-MM-DD") !== moment.utc(props.updatedProgramEndDate).local().format("YYYY-MM-DD") && props.stopPropagation.current) {
        props.stopPropagation.current = false;
        let tasks: any[] = [];
        let taskCount = 0;
        tasks = props.tasks.filter((task: any) => {
          let condition_1 = moment.utc(task.taskEndDate).local().format("YYYY-MM-DD") === moment.utc(props.programEndDate).local().format("YYYY-MM-DD");
          let condition_2 = moment.utc(task.taskEndDate).local().isAfter(moment.utc(props.updatedProgramEndDate).local());
          return condition_1 || condition_2;
        });
        tasks = tasks.map((task: any) => {
          return { ...task, taskEndDate: moment.utc(props.updatedProgramEndDate).local() };
        });

        if (isEmpty(tasks)) {
          setUpdatingTaskLoader(false);
          props.stopPropagation.current = true;
        }

        forEach(tasks, async (task) => {
          await updateTask({
            taskId: task.id,
            taskCreateDate: task.taskCreateDate,
            taskEndDate: task.taskEndDate,
            status: task.status,
            callback: () => {
              if (taskCount === tasks.length) {
                setTimeout(() => {
                  props.setProgramEndDate(props.updatedProgramEndDate);
                  setUpdatingTaskLoader(false);
                  props.stopPropagation.current = true;
                }, 3000);
              }
            },
          });
          taskCount += 1;
        });
      }
    };

    if (activeProgram.id === props.programId) {
      if (isAllComplete && props.programName === "HIC") {
        return;
      }
      updateTaskEndDate("taskWithSubTask | useEffect");
    }
  }, [activeProgram.id, props, props.programId, updateTask, updatedProgramEndDate]);

  const showAddTaskModal = () => {
    setIsAddTaskModalVisible(true);
  };

  const fetchTaskList = () => {
    setIsModalLoading(true);
    CareCoordinationService.fetchTaskList({ patientId: patientId, programId: props.programId, patientProgramId: props.patientProgramId }).subscribe({
      next: (v) => {
        setAddTaskOptions(v?.data?.data);
        setIsModalLoading(false);
      },
      error: (e) => {
        console.log(e);
        setIsModalLoading(false);
      },
    });
  };

  // function responsible to hide the add task options modal
  const handlePopUpCancel = () => {
    setIsAddTaskModalVisible(false);
  };

  // modifying add task options by excluding the already selected options
  const modifiedAddTaskOptions = () => {
    if (!isEmpty(searchValue)) {
      const options = filter(addTaskOptions, (task) => {
        return includes(task?.description?.toLowerCase(), searchValue?.toLowerCase());
      });
      return options;
    } else {
      return addTaskOptions;
    }
  };

  // adding new tasks
  const addNewTask = () => {
    setIsLoading(true);
    CareCoordinationService.createNewTask({
      patientId: patientId,
      interventionId: props?.interventionId,
      taskId: selectedNewTask,
      patientProgramId: props.patientProgramId,
    }).subscribe({
      next: (v) => {
        // const response = v;

        const newTasks = {
          id: selectedNewTask,
          status: ACTIVE,
          notes: [],
          description: get(find(addTaskOptions, { id: selectedNewTask }), "description", null),
        };

        if (isEmpty(activeIntervention.tasks)) {
          activeIntervention.tasks = [newTasks];
          activeInterventionPreviousState.tasks = [newTasks];
        } else {
          activeIntervention.tasks.push(newTasks);
          activeInterventionPreviousState.tasks.push(newTasks);
        }

        setProgramsData(programsData);
        setPreviousDataForCareCoordination(previousDataForCareCoordination);
        setIsAddTaskModalVisible(false);
        setIsLoading(false);
        props.onChangeProgram(props.programId);
      },
      error: (e) => {
        console.log(e);
        setIsAddTaskModalVisible(false);
        setIsLoading(false);
      },
    });
  };

  const onAccordionChange = (taskId?: any, ids?: any) => {
    if (taskId) {
      setActivePanel(ids ? [...activePanel, ids] : [...activePanel.filter((item: any) => item !== taskId)]);
    } else {
      if (activePanel.length > 0) {
        setActivePanel([]);
      } else
        setActivePanel(
          props.tasks.map((item: any) => {
            return item.id;
          })
        );
    }
  };

  return (
    <div className="ui-program-intervention-tasks">
      <div className="ui-program-intervention-tasks__heading">
        <span className="ui-program-intervention-tasks__heading__task-group-title">{props?.taskGroupName ? props?.taskGroupName : "HIC" === props.programName ? "Care Team Tasks" : "Tasks"}</span>
        {isEmpty(props.tasks) ? null : (
          <div className="ui-program-intervention-tasks__heading__section-2">
            {(("HIC" === props.programName && !isEmpty(filter(driversList, (item) => !isEmpty(item.assigneeLabel)))) || (!isEmpty(props.tasks) && "HIC" !== props.programName)) && (
              <>
                {props.showTaskGoals ? null : (
                  <div className="ui-program-intervention-tasks__heading__section-2__dates">
                    {/* <Icon name="calender" colorOfBrand="#0072e3" />
            <div className="ui-program-intervention-tasks__heading__dates__title">Task Duration:</div>
            {minCreateDate}
            <span className="ui-program-intervention-tasks__heading__dates__divider">-</span>
            {maxEndDate} */}
                    {/* Date format "MM-DD-YYYY" */}
                    <Icon name="calender" colorOfBrand="#0072e3" />
                    Task Goals |&nbsp;&nbsp;Min: {minCreateDate}&nbsp;&nbsp;-&nbsp;&nbsp;Max: {maxEndDate === "12-31-9999" ? "--/--/--" : maxEndDate}
                  </div>
                )}

                <div className="ui-program-intervention-tasks__heading__section-2__collapse-button" onClick={() => onAccordionChange()}>
                  <div className="ui-program-intervention-tasks__heading__section-2__collapse-button__label">{activePanel.length > 0 ? "Collapse All" : "Expand All"}</div>
                  <div className="ui-program-intervention-tasks__heading__section-2__collapse-button__icon">
                    <Icon name={`${activePanel?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {isEmpty(props.tasks) || ("HIC" === props.programName && isEmpty(filter(driversList, (item) => !isEmpty(item.assigneeLabel)))) ? (
        // <Empty description={"No Tasks Assigned."} />
        <DataNotFound message={NO_TASK_ASSIGNED} />
      ) : (
        <Spin spinning={isLoading || updatingTaskLoader} indicator={<HealthemSpinner />}>
          {map(props.tasks, (task, index) => {
            const taskId = get(task, "id", ACTIVE);
            const taskStatus = get(task, "status", ACTIVE);
            const taskDescription = get(task, "description", null);
            const taskOptions = isEmpty(get(task, "options", [])) ? [] : get(task, "options", []).replaceAll("'", "").split(",");
            const taskValue = isEmpty(get(task, "value", [])) ? [] : get(task, "value", []).replaceAll("'", "").replaceAll("[", "").replaceAll("]", "").split(", ");
            const taskType = get(task, "type", null);
            const taskCreateDate = moment.utc(get(task, "taskCreateDate", null)).local().format("MM-DD-YYYY");
            const taskEndDate = moment.utc(get(task, "taskEndDate", null)).local().format("MM-DD-YYYY");
            const name = get(task, "name", null);

            // const taskRule = get(task, "completionRule", null);
            const noteType = { taskId: taskId, noteType: MEMBER_DETAILS_CARE_MANAGEMENT_TASKS };

            // finding out if user can complete the task
            const subTasks = get(task, "subtasks", []);
            // const activeSubTasks = filter(subTasks, (subTask) => {
            //   return subTask?.status === ACTIVE;
            // });

            const taskExtraDescription = get(
              head(
                subTasks.filter((item: { options: string }) => {
                  return item.options === "TASKDSPLY";
                })
              ),
              "value",
              null
            );

            const activeRequiredSubTasks = filter(subTasks, (subTask) => {
              return isEmpty(subTask?.value) && subTask?.isMandatory === "Y";
            });

            // const completeSubTasks = filter(subTasks, (subTask) => {
            //   return subTask?.status === COMPLETE;
            // });

            // const canNotComplete =
            //   activeIntervention.status === COMPLETE
            //     ? true
            //     : taskStatus !== COMPLETE ||
            //       (taskRule === "ALLCHILD" && !isEmpty(activeSubTasks)) ||
            //       (taskRule === "ANYCHILD" && isEmpty(completeSubTasks)) ||
            //     (taskType !== ActionNoValue && isEmpty(taskValue));
            const canComplete = activeIntervention?.status === COMPLETE ? false : true;

            const btnClassNames = classNames("ui-program-intervention-tasks__task__actions__complete-action", {
              "ui-program-intervention-tasks__task__actions__complete-action--disabled": !canComplete,
            });

            return (
              <SpecificTask
                key={taskId + index}
                taskId={taskId}
                index={index}
                taskDescription={taskDescription}
                taskType={taskType}
                taskValue={taskValue}
                taskStatus={taskStatus}
                updateTask={updateTask}
                taskOptions={taskOptions}
                btnClassNames={btnClassNames}
                canComplete={canComplete}
                task={task}
                activeInterventionPreviousState={activeInterventionPreviousState}
                patientId={patientId}
                noteType={noteType}
                subTasks={subTasks}
                interventionId={props.interventionId}
                programId={props.programId}
                patientProgramId={props.patientProgramId}
                taskExtraDescription={taskExtraDescription}
                taskCreateDate={taskCreateDate}
                taskEndDate={taskEndDate}
                activeProgram={activeIntervention}
                activePanel={activePanel}
                onAccordionChange={onAccordionChange}
                spinner={isLoading}
                setSpinner={setIsLoading}
                name={name}
                canEdit={props?.canEdit}
                showAssignee={props?.showAssignee}
              />
            );
          })}
        </Spin>
      )}

      {get(activeIntervention, "status", ACTIVE) === ACTIVE && "CCM" === props.programName && (
        <div className="ui-program-intervention-tasks__add-new-task">
          <Button
            icon={<Icon name="plus-round" colorOfBrand={"#0072e3"} />}
            onClick={() => {
              fetchTaskList();
              showAddTaskModal();
              setSelectedNewTask([]);
            }}
            className="ui-program-intervention-tasks__add-new-task__button"
          >
            <span className="ui-program-intervention-tasks__add-new-task__text">Add Task</span>
          </Button>
        </div>
      )}

      <Modal
        className="ui-program-intervention-tasks__global-tasks"
        title="Add Task"
        visible={isAddTaskModalVisible}
        onCancel={handlePopUpCancel}
        footer={[
          <Button key="back" onClick={handlePopUpCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={addNewTask} disabled={isEmpty(selectedNewTask)}>
            Save
          </Button>,
        ]}
      >
        <Spin spinning={isModalLoading} indicator={<HealthemSpinner />}>
          <Input
            className="ui-program-intervention-tasks__global-tasks__search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            placeholder="Search"
            suffix={<Icon name="search" />}
          />
          <Radio.Group value={selectedNewTask} className="ui-program-intervention-tasks__global-tasks__options custom-scroll-bar" onChange={({ target: { value } }) => setSelectedNewTask(value)}>
            {map(modifiedAddTaskOptions(), (task, index) => {
              const optionClassName = classnames("ui-program-intervention-tasks__global-tasks__options__option", {
                "ui-program-intervention-tasks__global-tasks__options__option--selected": selectedNewTask === task?.id,
              });
              return (
                <Radio.Button className={optionClassName} key={task?.id + index} value={task?.id}>
                  {task?.description}
                </Radio.Button>
              );
            })}
          </Radio.Group>
        </Spin>
      </Modal>
    </div>
  );
};

const SpecificTask = ({
  taskId,
  index,
  taskDescription,
  taskType,
  taskValue,
  taskStatus,
  updateTask,
  taskOptions,
  btnClassNames,
  canComplete,
  task,
  activeInterventionPreviousState,
  patientId,
  noteType,
  subTasks,
  interventionId,
  programId,
  patientProgramId,
  taskExtraDescription,
  taskCreateDate,
  taskEndDate,
  activeProgram,
  onAccordionChange,
  activePanel,
  spinner,
  setSpinner,
  name,
  canEdit,
  showAssignee,
}: any) => {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [assineeName, setAssineeName] = useState<any>(null);
  const [isOrange, setOrange] = useState(false);
  // const [expand, setExpand] = useState(activePanel.includes(taskId) ? [taskId] : []);
  const driversList = useCareCoordinationStore((state) => state.driversList);
  const programsData = cloneDeep(useCareCoordinationStore((state) => state.dataForCareCoordination));
  // Force re-rendering the reminder component
  const [forceUpdateReminder, setForceUpdateReminder] = useState(false);

  const activeTaskPreviousState = find(activeInterventionPreviousState?.tasks, { id: taskId });
  // Validating if task has been assigned to any CM function
  const getAssignee = (taskDescription: any) => {
    const driver = find(driversList, { reviewReasonLabel: name });
    const assigneeName = driver?.assigneeLabel;
    return assigneeName;
  };

  // useEffect(() => {
  //   console.log("SpecificTask.useEffect.activePanel");
  //   setExpand(activePanel.includes(taskId) ? [taskId] : []);
  // }, [activePanel]);
  const textClassName = classNames({
    "color-orange": isOrange,
    noBorder: !isOrange,
  });

  const [isTaskValid] = useCareCoordinationStore((state: any) => [state.isTaskValid]);

  const isActiveTaskIsValid = isTaskValid(activeTaskPreviousState);

  const disabledDate: RangePickerProps["disabledDate"] = useCallback(
    (current) => {
      const start = moment(activeProgram.startDate).subtract(1, "days");
      const end = moment(activeProgram.endDate);
      return current <= start || current > end;
    },
    [activeProgram.startDate, activeProgram.endDate]
  );

  // disable collapse for HIC program if hic task is not assigned for any CM's
  // const disableCollapseForHICProgram = () => {
  //   return isEmpty(get(head(driversList.filter((item: any) => taskDescription.includes(head(item?.reviewReasonLabel?.split("-"))))), "assigneeLabel", undefined)) && programsData.description === "HIC"
  //     ? false
  //     : true;
  // };

  useEffect(() => {
    console.log("SpecificTask.useEffect2", taskId);

    const newAssinee = getAssignee(taskDescription);
    if (newAssinee !== assineeName) {
      setAssineeName(newAssinee);
    }
  }, [driversList]);

  useEffect(() => {
    setForceUpdateReminder(!forceUpdateReminder);
  }, [taskStatus])

  const [showMandatoryWarning, setshowMandatoryWarning] = useState<boolean>(false);

  const reminderRef = React.useRef<any>();

  const getExtra = () => {
    const currentMember =  membersService?.getCurrentMember;
    const getUserActionParams = (userActionDescription: any, reason: any) => {
      let props = {
        caseStatusReasonTxt: reason,
        actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
        actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
        actionCard: `${get(programsData , 'displayName')}$|${get(programsData, "patientProgramId")}$|${USER_ACTION_CARD_PROGRAM}`,
        actionLocation: `${taskDescription}$|${USER_ACTION_LOCATION_TASK_DROPDOWN}`,
        actionDescription: userActionDescription,
      };
      return props;
    };
    return (
      <div
        className="ui-program-intervention-tasks__task"
        key={taskId + index}
        onMouseOver={() => setShow2(true)}
        onMouseLeave={() => {
          setShow2(false);
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ui-program-intervention-tasks__task__header">
          {/* Description of the task */}
          <div className="ui-program-intervention-tasks__task__header__description">
            {/* <ReadMoreForWidth text={taskDescription} /> */}

            {/* commenting for task design redesign into accordion */}
            {/* <div style={{ display: "flex" }}>
              {taskDescription}
              <div className="ui-program-intervention-tasks__task__header__description__extra">{taskExtraDescription ? " - " + taskExtraDescription : null}</div>
            </div> */}
            <div
              className="ui-program-intervention-tasks__task__header__description__date"
              onClick={() => {
                taskStatus !== COMPLETE || taskStatus !== NOT_APPLICABLE ? setShow(true) : noop();
              }}
            >
              {
                <CareManagementCanEdit edit={canEdit} hide={false}>
                  <DateRange
                    rangeStartDate={taskCreateDate}
                    rangeEndDate={taskEndDate === "12-31-9999" ? null : taskEndDate}
                    disabledDate={disabledDate}
                    disabledDates={taskStatus === COMPLETE || taskStatus === NOT_APPLICABLE ? [true, true] : [false, false]}
                    handleDateChange={(range: any[]) => {
                      setOrange(true);
                      updateTask({
                        taskId: taskId,
                        taskCreateDate: range[0],
                        taskEndDate: range[1],
                        status: taskStatus,
                        callback: () => {
                          setTimeout(() => {
                            setShow(false);
                            setOrange(false);
                          }, 3000);
                        },
                      });
                    }}
                    format={"MM-DD-YYYY"}
                    format_1={"MM-DD-YYYY"}
                    format_2={"MM-DD-YYYY"}
                    picker="date"
                    className={`${textClassName} ${show || show2 ? "task-visibility-on-hover" : ""}`}
                    onOpenChange={(open: boolean) => {
                      if (!open) {
                        setTimeout(() => {
                          setShow(false);
                        }, 3000);
                      }
                    }}
                  />
                </CareManagementCanEdit>
              }
            </div>
          </div>
          {taskType === Info &&
            (size(taskValue) > 1 ? (
              <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
                <Panel header="" key="1">
                  {map(taskValue, (value) => {
                    return <ReadMoreForWidth text={value} />;
                  })}
                </Panel>
              </Collapse>
            ) : (
              map(taskValue, (value) => {
                return <ReadMoreForWidth text={value} />;
              })
            ))}

          {taskType !== ActionNoValue && (
            <div className="ui-program-intervention-tasks__task__header__value">
              {/* Value of the task */}
              {taskType === ActionFreeText && (
                <InputField
                  value={taskValue}
                  disabled={taskStatus === COMPLETE || taskStatus === NOT_APPLICABLE || taskType === Info}
                  onBlur={(value) => updateTask({ value: value, taskId: taskId, status: taskStatus })}
                />
              )}
              {/** Options */}
              {taskType === ActionRadio && (
                <Radio.Group value={taskValue} onChange={({ target: { value } }) => updateTask({ value: value, taskId: taskId, status: taskStatus })}>
                  {map(taskOptions, (option, index) => {
                    return (
                      <Radio key={option + index} value={option}>
                        {option}
                      </Radio>
                    );
                  })}
                </Radio.Group>
              )}
            </div>
          )}
        </div>
        <CareManagementCanEdit edit={canEdit} hide={false}>
          <div className="ui-program-intervention-tasks__task__actions">
            {/* Reminder */}
            <Remainder
              innerRef={reminderRef}
              masterData={task}
              patientId={patientId}
              taskId={taskId}
              interventionId={interventionId}
              dependentSectionId={{ reminderType: noteType.noteType, taskId: noteType.taskId }}
              disabled={taskStatus === COMPLETE || taskStatus === NOT_APPLICABLE || taskType === Info ? true : false}
              taskType={taskType}
              updateParentTask={(newReminder: any) => updateTask({ status: INPROGRESS, taskId: taskId, newReminder: newReminder })}
              listOfReminders={get(task, "reminders", []).concat(...(task.subtasks || []).map((st: any) => st.reminders || []))}
              reminderOrigin={MEMBER_DETAILS_CARE_MANAGEMENT_TASKS}
              forceUpdateReminder={forceUpdateReminder}
            />

            {/* Note */}

            <Notes
              masterData={task}
              patientId={patientId}
              noteType={noteType}
              disabled={taskStatus === COMPLETE || taskStatus === NOT_APPLICABLE || taskType === Info ? true : false}
              taskId={taskId}
              interventionId={interventionId}
              taskType={taskType}
              updateParentTask={() => updateTask({ status: INPROGRESS, taskId: taskId })}
              screen={CARE_MANAGEMENT_SCREEN_TITLE}
            />

            {/* Complete and Active Action */}
            <div
              className={`ui-program-intervention-tasks__task__actions__drop-down ${
                taskType === Info && taskStatus === COMPLETE
                  ? "done"
                  : taskStatus === NOT_APPLICABLE
                  ? "notApplicable"
                  : taskStatus === ACTIVE
                  ? "active"
                  : taskStatus === INPROGRESS
                  ? "inProgress"
                  : "done"
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {/* <div
                className={`ui-program-intervention-tasks__task__actions__drop-down__dot ${taskStatus === COMPLETE ? "status-green" : taskStatus === INPROGRESS ? "status-yellow" : "status-blue"}`}
              /> */}
              <Select
                size="small"
                value={taskStatus}
                onClick={(e) => e.stopPropagation()}
                onChange={(status: any) => {
                  if (!canComplete) {
                    return false;
                  }
                  if (status === COMPLETE && !isActiveTaskIsValid) {
                    setshowMandatoryWarning(true);
                    return false;
                  }
                  updateTask({ status: status, taskId: taskId, taskEndDate: status === COMPLETE || status === NOT_APPLICABLE ? moment() : activeProgram?.endDate, callback: () => {
                    setForceUpdateReminder(!forceUpdateReminder)
                  } });
                  const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
                    USER_ACTION_DESCRIPTION_TASK_STATUS_CHANGE,
                    CASE_STATUS_REASON_TASK_STATUS
                  );
                  membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
                    next: (v) => {
                      console.log("updated status successfully")
                    },
                    error: (e) => {
                      console.log("update status failed")
                    },
                  });
                }}
              >
                {CARE_MANAGEMENT_TASK_STATUS_DROPDOWN_MAPPING.map((item: any) => (
                  <Option
                    key={item.value}
                    value={item.value}
                    disabled={
                      item.value === ACTIVE ||
                      // (taskStatus === INPROGRESS ? (moment() < moment(taskCreateDate) ? false : item?.value === NOT_APPLICABLE) : false) ||
                      (moment() < moment(taskCreateDate) && item.value === COMPLETE)
                      // (taskStatus === COMPLETE && item.value === NOT_APPLICABLE)
                    }
                  >
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
            {showMandatoryWarning && (
              <MandatoryWarning
                show={showMandatoryWarning}
                setshow={setshowMandatoryWarning}
                onContinue={
                  () => {
                    let status = COMPLETE
                    updateTask({ status: status, taskId: taskId, taskEndDate: status === COMPLETE ? moment() : activeProgram?.endDate, callback: () => {
                      setForceUpdateReminder(!forceUpdateReminder)
                    } });
                    const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
                      USER_ACTION_DESCRIPTION_TASK_STATUS_CHANGE,
                      CASE_STATUS_REASON_TASK_STATUS
                    );
                    membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
                      next: (v) => {
                        console.log("updated status successfully")
                      },
                      error: (e) => {
                        console.log("update status failed")
                      },
                    });
                    setshowMandatoryWarning(false)
                  }
                }
              >
                Mandatory fields are not filled. Do you still want to close the task
              </MandatoryWarning>
            )}
          </div>
        </CareManagementCanEdit>
      </div>
    );
  };

  return (!isEmpty(assineeName) && programsData.description === "HIC") || programsData.description !== "HIC" ? (
    <span className={subTasks.length > 0 ? "" : "task-collapse-panel-default-cursor"}>
      <Collapse
        accordion={true}
        activeKey={subTasks.length > 0 ? (activePanel.includes(taskId) ? [taskId] : []) : []}
        expandIconPosition="right"
        bordered={false}
        onChange={(key: any) => {
          onAccordionChange(taskId, key);
          // setExpand(key);
        }}
        collapsible={"icon"}
      >
        <Panel
          // className="title"
          header={
            <div
              onMouseOver={() => setShow2(true)}
              onMouseLeave={() => {
                setShow2(false);
              }}
              className="specificTaskAccordion-header"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="specificTaskAccordion-header__label">{taskDescription}</div>
              {programsData.description === "HIC" && !isEmpty(assineeName) && showAssignee && (
                <div className="specificTaskAccordion-header__assigned-user">
                  <UserOutlined style={{ fontSize: "13px" }} />
                  <span className="specificTaskAccordion-header__assigned-user__name">{assineeName}</span>
                </div>
              )}
            </div>
          }
          key={taskId}
          style={{ marginBottom: "8px" }}
          extra={getExtra()}
          // collapsible={"icon"}
          // showArrow={subTasks.length > 0 && disableCollapseForHICProgram()}
          showArrow={subTasks.length > 0}
        >
          <SubTask
            completeParentTask={() => updateTask({ status: COMPLETE, taskId: taskId })}
            interventionId={interventionId}
            programId={programId}
            patientProgramId={patientProgramId}
            taskId={taskId}
            patientId={patientId}
            updateParentTaskNew={updateTask}
            updateParentTask={({ activeTask, stopPrevProgramDataUpdate }: any) => updateTask({ taskId: taskId, status: INPROGRESS, activeTaskFromSubTask: activeTask, stopPrevProgramDataUpdate })}
            taskDescription={taskDescription}
            spinner={spinner}
            setSpinner={setSpinner}
            canEdit={canEdit}
            taskReminderRef={reminderRef}
            forceUpdateReminder={forceUpdateReminder}
          />
        </Panel>
      </Collapse>
    </span>
  ) : null;
};

export default Task;
